import { isStagingEnvironment } from '@/lib/staging-environment';

/**
 * Always-on, non-dismissible staging marker. Hostname-gated so production
 * hosts never render it ([STG-CHROME-1]).
 */
export function StagingRibbon() {
  if (!isStagingEnvironment()) return null;

  return (
    <div
      role="status"
      aria-label="Staging environment"
      className="larkpm-staging-ribbon"
    >
      Staging
    </div>
  );
}
